import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["id", "disabled"]
const _hoisted_3 = ["id", "disabled"]

import {useId} from "vue"

  
export default /*@__PURE__*/_defineComponent({
  __name: 'text',
  props: /*@__PURE__*/_mergeModels({
    multiline: {
      default: false,
      required: false,
      type: Boolean
    },
    readOnly: {
      default: false,
      required: false,
      type: Boolean
    },
    title: {
      default: null,
      required: false,
      type: String
    }
  }, {
    "value": {
    default: null,
    required: true,
    type: String
  },
    "valueModifiers": {},
  }),
  emits: ["update:value"],
  setup(__props) {

  

  const id = useId()
  const value = _useModel(__props, "value")

return (_ctx: any,_cache: any) => {
  const _component_scoped = _resolveComponent("scoped")!

  return (_openBlock(), _createBlock(_component_scoped, null, {
    default: _withCtx(() => [
      (__props.title)
        ? (_openBlock(), _createElementBlock("label", {
            key: 0,
            for: _unref(id)
          }, _toDisplayString(__props.title), 9, _hoisted_1))
        : _createCommentVNode("", true),
      (!__props.multiline)
        ? _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 1,
            id: _unref(id),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
            type: "text",
            disabled: __props.readOnly
          }, null, 8, _hoisted_2)), [
            [_vModelText, value.value]
          ])
        : _createCommentVNode("", true),
      (__props.multiline)
        ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
            key: 2,
            id: _unref(id),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((value).value = $event)),
            rows: "5",
            disabled: __props.readOnly
          }, null, 8, _hoisted_3)), [
            [_vModelText, value.value]
          ])
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})